var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurrenderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c479d;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono Rendicion de Cuentas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cabecera"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 220,
    height: 275
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.65,65.15,147,30.5H43.9v113a29,29,0,0,0-16.59,50.79v48.67h6.84l12.24-12.25,12.25,12.25h6.84V221.35H181.65ZM148.46,39l24.69,24.69H148.46ZM22.33,172.39a24.07,24.07,0,1,1,24.06,24.07,24.1,24.1,0,0,1-24.06-24.07Zm24.06,51.25-14.1,14.11v-40a28.94,28.94,0,0,0,28.21,0v40Zm19.09-7.27V194.26a29,29,0,0,0-16.6-50.79v-108h94.6V68.67h33.19v147.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 66.31,
    y: 57.05,
    width: 39.83,
    height: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 66.31,
    y: 70.33,
    width: 26.55,
    height: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 66.31,
    y: 90.24,
    width: 92.94,
    height: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 66.31,
    y: 103.52,
    width: 92.94,
    height: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 66.31,
    y: 130.07,
    width: 92.94,
    height: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.59,
    y: 143.35,
    width: 66.38,
    height: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 66.31,
    y: 116.8,
    width: 92.94,
    height: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.41,
    y: 163.27,
    width: 39.83,
    height: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 132.69,
    y: 176.54,
    width: 26.55,
    height: 4.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.39,188.16a15.77,15.77,0,1,0-15.76-15.77,15.78,15.78,0,0,0,15.76,15.77Zm0-26.55a10.79,10.79,0,1,1-10.78,10.78,10.79,10.79,0,0,1,10.78-10.78Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurrenderIcon);
export default __webpack_public_path__ + "static/media/surrenderIcon.ae3213f1f459272f5198a39cedb75541.svg";
export { ForwardRef as ReactComponent };